import(/* webpackMode: "eager", webpackExports: ["ByoidProvider"] */ "/app/src/app/_components/NDR/ByoidProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NdrWrapper"] */ "/app/src/app/_components/NDR/Wrappers/NdrWrapper.tsx");
